export default {
  "content": "<path d=\"M9 3v5.5H7V3h2zM8 13a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};